import React from 'react';
import { Container, Button } from 'react-bootstrap';
import FormSectionCard from '../FormSectionCard';
import CreateUsersForm from './CreateUsersForm';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const MLB_OAUTH_START_URL = `${API_BASE_URL}/api/integrations/mercado-livre/oauth/start`;

const Settings = () => {
  const [expandedMercadoLivre, setExpandedMercadoLivre] = React.useState(true);
  const [expandedCreateUsers, setExpandedCreateUsers] = React.useState(true);

  return (
    <div className="page-dark">
      <Container>
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Manage platform settings and users.</p>

        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 col-xl-6 mb-4">
            <FormSectionCard
              title="Mercado Livre"
              expanded={expandedMercadoLivre}
              onToggle={() => setExpandedMercadoLivre((prev) => !prev)}
            >
              <p className="text-muted small mb-3">
                Connect your Mercado Livre account to sync listings and categories. You will be redirected to Mercado Livre to authorize.
              </p>
              <Button
                as="a"
                href={MLB_OAUTH_START_URL}
                variant="primary"
                target="_self"
                rel="noopener noreferrer"
              >
                Connect Mercado Livre
              </Button>
            </FormSectionCard>

            <FormSectionCard
              title="Create users"
              expanded={expandedCreateUsers}
              onToggle={() => setExpandedCreateUsers((prev) => !prev)}
            >
              <CreateUsersForm />
            </FormSectionCard>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Settings;
